import { formatMoneyDisplay } from '../finance/financeMoney';
import './journey-cost.css';

/**
 * 金額摘要卡（總預算／已記支出／剩餘額度等）。
 */
export default function CostMoneySummary({
  title,
  currency,
  amount,
  meta,
  className = '',
}) {
  const display = formatMoneyDisplay(amount);
  const currencyCode = currency ? String(currency) : '';
  const ariaLabel = [title, display, currencyCode].filter(Boolean).join(' ');

  return (
    <div
      className={`journey-cost-money-summary${className ? ` ${className}` : ''}`}
      data-testid="cost-money-summary"
      aria-label={ariaLabel}
    >
      <p className="journey-cost-money-summary__title">{title}</p>
      <p className="journey-cost-money-summary__amount">
        {display}
        {currencyCode ? ` ${currencyCode}` : ''}
      </p>
      {meta ? <p className="journey-cost-money-summary__meta">{meta}</p> : null}
    </div>
  );
}
